// @ts-nocheck


import React, { useState, useCallback } from 'react';
import { navigate } from '../../lib/routerAdapter';

import { expertiseServiceGpmCostApi } from '../../lib/api';

import { formatDateTimeToString } from '../../lib/helpers';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import Grid, { GridItem } from '../../components/layout/Grid';
import { Card } from '../../components';

import { withUserAccess } from './../withUserAccess';

import { addAccessRight } from './accessRight';
import { approveTypes } from '../../lib/enum';
import { getBreadCrumbsByUrlForCard } from '../../lib/autoBreadcrumbs';

const { Field } = Card;










const entryPointPath = '/admin/expertise-service-gpm-cost/';

const InnerForm = (props) => {
  return (
    <>
      <Grid gutter="16px">
        <GridItem>
          <Field label="Подразделение">{props.data.orgUnitName}</Field>
        </GridItem>
        <GridItem>
          <Field label="Стоимость нормочаса на ТО ГПМ без НДС, руб">
            {props.data.workHour}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Количество часов на одно ТО ГПМ">
            {props.data.workHoursCount}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Сумма на сопутствующие материалы одного ТО ГПМ без НДС, руб">
            {props.data.materialsCost}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Периодичность прохождения ТО ГПМ">
            {props.data.maintenanceIntervals}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Стоимость одной экспертизы промышленной безопасности без НДС, руб">
            {props.data.expertiseCost}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Дата начала">
            {formatDateTimeToString(props.data.startDate, 'DD.MM.YYYY')}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Дата окончания">
            {formatDateTimeToString(props.data.endDate, 'DD.MM.YYYY')}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Статус">{approveTypes[props.data.status]}</Field>
        </GridItem>
      </Grid>
    </>);

};

export default withUserAccess((props) => {
  const [data, setData] = useState({
    id: props.id,
    name: '',
    isAvailableForSelect: false
  });

  const breadCrumbs = getBreadCrumbsByUrlForCard(entryPointPath, data.id);

  const canEdit = props.userAccess.some((access) =>
  addAccessRight.includes(access)
  );

  const access = {
    delete: canEdit ?
    async () => {
      await expertiseServiceGpmCostApi.delete(data.id);
      await navigate(`${entryPointPath}`);
    } :
    false,
    edit: canEdit ?
    async () => await navigate(`${entryPointPath}edit/${data.id}`) :
    false
  };

  const onFetch = useCallback(async () => {
    setData(await expertiseServiceGpmCostApi.get(props.id));
  }, [props.id]);

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость ТО ГПМ и промышленной экспертизы',
        access
      }}
      onFetch={onFetch}>

      <InnerForm data={data} />
    </CommonCardPage>);

});
